/** Checking that code length is less then 8 and code is number */
const isCodeInputValid = (code: string) =>
  code === "" ||
  (!isNaN(code as any) && !isNaN(parseFloat(code)));

/** Removing "." and "-" symbols from code */
const cleanInput = (input: string) =>
  input.replaceAll("-", "").replaceAll(".", "").replaceAll(" ", "").substring(0, 8);

export { isCodeInputValid, cleanInput };
